import React from 'react';
import { CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { checkoutUrl, offer } from '../data/content';
interface PricingProps {
  showUrgency?: boolean;
}
export function Pricing({
  showUrgency = true
}: PricingProps) {
  return <section id="planes" className="w-full bg-white py-16 md:py-24" data-id="element-143" data-mp="2jlyvnpqj53jz">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-144" data-mp="1vujy0a9p7af2">
        {showUrgency && <CountdownPanel data-id="element-145" data-mp="1rthvnkkhii8v" />}

        <h2 className="mt-16 text-center font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-146" data-mp="1ru9lsfvbbnrr">
          Tu <span className="text-gold-600" data-id="element-147" data-mp="20tefn8vxisxl">MegaPack BIO-RESET 5.0</span>
        </h2>

        <div className="mx-auto mt-10 max-w-narrow rounded-2xl bg-blue-900 p-7 text-white shadow-lift ring-1 ring-gold-500 md:p-10" data-id="element-148" data-mp="3h7ed8d7ay6ho">
          <p className="text-center font-display text-xl font-extrabold uppercase tracking-tight text-gold-300 md:text-2xl" data-id="element-149" data-mp="3c93301d3htyx">
            {offer.name}
          </p>
          <p className="mt-2 text-center text-lg text-blue-100" data-id="element-150" data-mp="4t5lrddrd9yk">{offer.summary}</p>

          <ul className="mx-auto mt-8 grid max-w-xl gap-4 text-left sm:grid-cols-2" data-id="element-151" data-mp="4v8lip4pqhgh">
            {offer.includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-152" data-mp="er1yuaq9aezb">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold-500 text-ink" data-id="element-153" data-mp="ep8wv8ql8ixn">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-154" data-mp="3i7sgjmv7aggu" />
                </span>
                <span className="text-white" data-id="element-155" data-mp="3n754yc1pzvlj">{item}</span>
              </li>)}
          </ul>

          <div className="mt-10 text-center" data-id="element-156" data-mp="3rxlhzv1mpf7d">
            <p className="text-lg text-blue-200 line-through" data-id="element-157" data-mp="3rzep1bg5m1fw">{offer.listPrice} ARS</p>
            <p className="font-display text-5xl font-extrabold tracking-tight text-white md:text-6xl" data-id="element-158" data-mp="2uhekll9hvxgz">
              {offer.price}
              <span className="ml-2 text-xl font-semibold text-blue-200" data-id="element-159" data-mp="2zfg6edyb2aw5">ARS</span>
            </p>
            <p className="mt-3 inline-block rounded-lg bg-gold-500 px-4 py-1.5 font-display text-sm font-extrabold uppercase tracking-wide text-ink" data-id="element-160" data-mp="2res0i3enaqwc">
              {offer.savings}
            </p>
          </div>

          <div className="mt-8" data-id="element-161" data-mp="318ikow3qof68">
            <CtaButton size="xl" className="w-full" href={checkoutUrl} data-id="element-162" data-mp="2w71q1ibuloy3">
              {offer.cta}
            </CtaButton>
          </div>

          <p className="mt-5 text-center text-sm text-blue-100" data-id="element-163" data-mp="28iinljfhc6dx">
            Acceso inmediato en PDF | 100% listo para imprimir o usar desde el celular
          </p>
        </div>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-164" data-mp="2ih80sywfl2nu">
          <li className="inline-flex items-center gap-2" data-id="element-165" data-mp="2dfscmxyyig18">
            <LockIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-166" data-mp="3tuk5td3xfrbl" /> Pago 100% seguro
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-167" data-mp="3ov7ae3yzpbxe">
            <ZapIcon className="h-4 w-4 text-gold-600" aria-hidden="true" data-id="element-168" data-mp="adkyqf5ttj0" /> Acceso en 5 minutos
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-169" data-mp="5971ystno2nx">
            <ShieldCheckIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-170" data-mp="5arvcf48hfk7" /> Garantía 7 días
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-171" data-mp="3nhfxbw3zlmln">
            <CreditCardIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-172" data-mp="3rhgaldfcnrr4" /> Mercado Pago |
            Transferencia
          </li>
        </ul>
      </div>
    </section>;
}